import InputUncontrolled from "../../components/InputUncontrolled";

export default function ApplicantFields({ data, errors }) {
	return (
		<>
			<div className="two">
				<div>
					<InputUncontrolled
						type="text"
						label="First Name"
						req={true}
						name="fname"
						value={data.fname}
						errors={errors}
						autocomplete="given-name"
					/>
				</div>
				<div>
					<InputUncontrolled
						type="text"
						label="Last Name"
						req={true}
						name="lname"
						value={data.lname}
						errors={errors}
						autocomplete="family-name"
					/>
				</div>
			</div>

			<div className="two">
				<div>
					<InputUncontrolled
						type="text"
						label="Email Address"
						req={true}
						name="email"
						value={data.email}
						errors={errors}
						autocomplete="email"
					/>
				</div>
				<div>
					<InputUncontrolled
						type="text"
						label="Phone Number"
						req={true}
						name="phone"
						value={data.phone}
						errors={errors}
						autocomplete="tel"
					/>
				</div>
			</div>
		</>
	);
}
